export default __webpack_public_path__ + "static/media/Certilytics-Logo-Icons-3.04b862fd.svg";